module.exports = __webpack_public_path__ + "img/m-3d-loading.7cc7e0da.gif";